import { toast } from 'react-toastify';

/**
 * Show success toast notification
 */
export const showSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show error toast notification
 */
export const showError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show info toast notification
 */
export const showInfo = (message) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show warning toast notification
 */
export const showWarning = (message) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Show confirmation dialog using toast
 * Returns a promise that resolves to true if confirmed, false otherwise
 */
export const showConfirm = (message, onConfirm, onCancel) => {
  const toastId = toast(
    ({ closeToast }) => (
      <div style={{ padding: '0.5rem' }}>
        <p style={{ marginBottom: '1rem', fontWeight: 'bold' }}>{message}</p>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button
            onClick={() => {
              closeToast();
              if (onCancel) onCancel();
            }}
            style={{
              padding: '0.5rem 1rem',
              background: '#e2e8f0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              closeToast();
              if (onConfirm) onConfirm();
            }}
            style={{
              padding: '0.5rem 1rem',
              background: '#e53e3e',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    ),
    {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: true,
    }
  );
  
  return toastId;
};

/**
 * Promise-based confirmation dialog
 */
export const confirmDialog = (message) => {
  return new Promise((resolve) => {
    const toastId = showConfirm(
      message,
      () => resolve(true),
      () => resolve(false)
    );
  });
};
